'use client';

import { sanitizeIntranetCallback } from '@/lib/auth/constants';
import { getIntranetLinkPrefix } from '@/lib/intranet';
import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import styles from '@/app/(home)/auth/auth.module.css';

const ERROR_MESSAGES: Record<string, string> = {
  microsoft_denied: 'Accesso annullato o negato da Microsoft.',
  microsoft_invalid_request: 'Richiesta di accesso non valida. Riprova.',
  microsoft_invalid_state: 'Sessione di accesso scaduta. Riprova.',
  microsoft_token_exchange: 'Impossibile completare l\'accesso con Microsoft.',
  microsoft_identity: 'Account Microsoft non autorizzato per l\'intranet.',
  strapi_bridge: 'Impossibile collegare l\'account. Contatta l\'amministratore.',
  account_blocked: 'Il tuo account è stato bloccato. Contatta l\'amministratore.',
};

function LoginFormContent() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const prefix = getIntranetLinkPrefix(pathname);
  const callbackUrl = sanitizeIntranetCallback(
    searchParams.get('callbackUrl'),
    prefix,
  );

  const errorCode = searchParams.get('error');
  const errorMessage = errorCode ? ERROR_MESSAGES[errorCode] : null;

  const loginHref = `/api/auth/microsoft/login?callbackUrl=${encodeURIComponent(callbackUrl)}`;

  return (
    <div className={styles.authWrapper}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-7">
            <div className={`card shadow-sm ${styles.authCard}`}>
              <div className="card-body p-4 p-md-5">
                <h1 className={`h3 fw-bold mb-3 ${styles.authHeader}`}>Accedi</h1>
                <p className={`mb-4 ${styles.authSubtitle}`}>
                  Area riservata al personale interno. Usa il tuo account
                  Microsoft 365 aziendale.
                </p>

                {errorMessage ? (
                  <div className="alert alert-danger" role="alert">
                    {errorMessage}
                  </div>
                ) : null}

                <div className="d-grid">
                  <a
                    href={loginHref}
                    className="btn btn-primary btn-lg d-inline-flex align-items-center justify-content-center gap-2"
                  >
                    <span
                      className="bi bi-microsoft"
                      aria-hidden="true"
                    />
                    Accedi con Microsoft 365
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function IntranetLoginForm() {
  return (
    <Suspense fallback={<div className={styles.authWrapper} />}>
      <LoginFormContent />
    </Suspense>
  );
}
